import { render } from "./PdfComponent.vue?vue&type=template&id=2ffa223a"
import script from "./PdfComponent.vue?vue&type=script&lang=js"
export * from "./PdfComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__